import { type FunctionComponent } from "react";
import TextField from "@/react/core/TextField";
import TextArea from "@/react/core/TextArea.tsx";
import { selectedUser } from "@/react/UserSettingView/UserSettingView.tsx";
import _ from "lodash";
import { LL0 } from "@/react/core/I18nService.tsx";

const DriverInfoForm: FunctionComponent = () => {

  const driverInfo = selectedUser()?.driverInfo

  const handleChange = (value: string, field: string) => {
    if (!driverInfo) {
      _.assign(selectedUser(), {driverInfo: {primaryPhone: "", secondPhone: "", email: "", vehicleLicense: "", vehicleDescription: ""}})
    }
    _.assign(driverInfo, {[field]: value})
  }

  return (
    <>
      <div
        className="self-stretch overflow-hidden shrink-0 flex flex-col items-start justify-start py-0 px-6 gap-[16px_0px] text-left text-base text-black-solid-black-880-1d1d26 font-mulish sm:gap-[6px_0px] sm:pl-4 sm:pr-4 sm:box-border Tablet_768:gap-[4px_0px] Tablet_768:pl-4 Tablet_768:pr-4 Tablet_768:box-border Tablet_600:gap-[4px_0px] Tablet_600:pl-3 Tablet_600:pr-3 Tablet_600:box-border Mobile_480:pl-3 Mobile_480:pr-3 Mobile_480:box-border mq320:pl-2.5 mq320:pr-2.5 mq320:box-border">
        <div
          className="w-full flex gap-[0px_44px] sm:gap-[0px_36px] Tablet_768:gap-[0px_30px] Tablet_600:gap-[0px_28px] Mobile_480:gap-[0px_20px] mq320:gap-[0px_16px]">
          <div className="flex-1 flex flex-col gap-2">
            <div className="text-[12px]">{LL0().settings.userSettings.primaryPhoneNumber()}<span className="text-[#ec3323]">*</span></div>
            <TextField
              value={driverInfo?.primaryPhone}
              onChange={(e) => handleChange(e.target.value, "primaryPhone")}
            />
          </div>
          <div className="flex-1 flex flex-col  gap-2">
            <div className="text-[12px]">{LL0().settings.userSettings.secondaryPhoneNumber()}</div>
            <TextField
              value={driverInfo?.secondPhone}
              onChange={(e) => handleChange(e.target.value, "secondPhone")}
            />
          </div>
        </div>
        <div
          className="w-full flex gap-[0px_44px] sm:gap-[0px_36px] Tablet_768:gap-[0px_30px] Tablet_600:gap-[0px_28px] Mobile_480:gap-[0px_20px] mq320:gap-[0px_16px]">
          <div className="flex-1 flex flex-col gap-2">
            <div className="text-[12px]">{LL0().settings.userSettings.emailAddress()}</div>
            <TextField
              value={driverInfo?.email}
              onChange={(e) => handleChange(e.target.value, "email")}
            />
          </div>
          <div className="flex-1 flex flex-col gap-2">
            <div className="text-[12px]">{LL0().settings.userSettings.vehicleLicensePlate()}</div>
            <TextField
              value={driverInfo?.vehicleLicense}
              onChange={(e) => handleChange(e.target.value, "vehicleLicense")}
            />
          </div>
        </div>
        <div className="w-full flex-1 flex flex-col gap-2">
          <div className="text-[12px]">{LL0().settings.userSettings.vehicleDescription()}</div>
          <TextArea
            className="w-full"
            value={driverInfo?.vehicleDescription}
            onChange={(value) => handleChange(value, "vehicleDescription")}
          />
        </div>
      </div>
      <div
        className="self-stretch relative box-border h-px shrink-0 border-t-[1px] border-solid border-gray-solid-gray-360-d6d5d5"/>
    </>
  )
}

export default DriverInfoForm;